<template>
  <div :class="$style.box">
    <!-- 回复者信息 -->
    <div :class="$style.replier">
      <HeadImage :headImage="replyItem.forum_image" :headCircleImage="replyItem.identity_image" />
      <div :class="$style['replier-info']">
        <p>{{ replyItem.forum_name }}<span v-if="replyItem.is_publisher == 1">楼主</span></p>
        <p>{{ replyTime }}</p>
      </div>
      <!-- 点赞 -->
      <div
        v-if="!replyItem.is_support"
        :class="$style['thumb-clicked']"
        @click.stop.once="doThumbClicked"
      >
        <img :src="like_icon" />
        <span>{{ replyItem.support }}</span>
      </div>
      <div v-else :class="$style['thumb-clicked']">
        <img :src="red_like_icon" />
        <span :style="{ color: '#fb7166' }">{{ replyItem.support }}</span>
      </div>
    </div>
    <!-- 回复内容 -->
    <div :class="$style['reply-content']">
      <div v-html="replyTextContent"></div>
      <img
        v-for="(item, index) in replyImgList"
        :key="index"
        v-lazy="item"
        alt
        @click.stop="previewImage(item)"
      />
    </div>
    <!-- 底部 -->
    <div :class="$style.footer">
      <div
        v-if="!isSecondReply && replyNumber && !isPoster"
        :class="$style['reply-number']"
        @click="viewReply"
      >
        <span>{{ '查看' + replyNumber + '条回复' }}</span>
      </div>
      <div :class="$style['reply-number']" v-else @click="doReply">
        <img :src="reply_icon" />
        <span>{{ '回复' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import HeadImage from '_c/HeadImage';
import { doPraise } from '@/api/gameCircle';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from '@/config/index.js';
import { pastTime } from '@/utils/index';
export default {
  components: {
    HeadImage,
  },
  props: {
    // 判断是否是楼主
    isPoster: {
      type: Boolean,
      default: false,
    },
    listItem: {
      type: Object,
      default: () => {},
    },
    // 是否为二级回复
    isSecondReply: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      like_icon: `${CDN_URL}/praise_1.png`, // 点赞小图标
      red_like_icon: `${CDN_URL}/red_praise_1.png`, // 红色点赞小图标
      reply_icon: `${this.$cdnUrl}/chat_1.png`, // 回复小图标
      replyItem: {},
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false;
      return flag;
    },
    replyTime() {
      return pastTime(this.replyItem.created_at);
    },
    replyTextContent() {
      if (!this.replyItem.content || this.replyItem.content[0] != '{')
        return this.replyItem.content;
      let content = JSON.parse(this.replyItem.content);
      let resText = this.isSecondReply
        ? `回复<span class="blue">@${this.parentName}：</span>${content.text}`
        : content.text;
      return resText;
    },
    replyImgList() {
      if (!this.replyItem.content || this.replyItem.content[0] != '{') return [];
      let content = JSON.parse(this.replyItem.content);
      return content.imgList;
    },
    replyNumber() {
      return this.listItem.comment;
    },
    parentName() {
      return this.listItem.parent_forum_name;
    },
  },
  watch: {
    listItem: {
      handler(newValue) {
        this.replyItem = { ...newValue };
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
    }),
    // 回复列表点赞
    async doThumbClicked() {
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true);
        return;
      }
      this.replyItem.is_support = 1;
      this.replyItem.support++;
      const r = await doPraise({
        comment_id: this.replyItem.id, // 回复列表id
      });
    },
    // 查看回复
    viewReply() {
      this.$emit('openMultilevelReply', this.replyItem);
    },
    // 回复
    doReply() {
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true);
        return;
      }
      this.$emit('openReplyField', this.replyItem);
    },
    previewImage(item) {
      this.$emit('openPopup', { currentImage: item, replyImageList: this.replyImgList });
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  @include border-bottom-1px;
  width: 340px;
  min-height: 72px;
  font-size: 10px;
  font-weight: 400;
}
.replier {
  padding-left: 8px;
  width: 100%;
  display: flex;
  .replier-info {
    position: relative;
    left: -5px;
    width: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p:first-child {
      margin-right: 5px;
      font-size: 14px;
      font-weight: bold;
      // position: relative;
    }
    p:last-child {
      display: inline-block;
      margin-top: 2px;
      line-height: 18px;
      font-size: 10px;
      color: rgba(159, 159, 159, 1);
    }
    span {
      width: 24px;
      line-height: 16px;
      text-align: center;
      font-size: 8px;
      background-color: rgba(40, 169, 251, 1);
      color: #fff;
      position: absolute;
      margin-left: 6px;
      top: 13px;
    }
  }
  .thumb-clicked {
    height: 15px;
    margin-top: 8px;
    padding: 10px;
    box-sizing: content-box;
    flex: none;
    & > img {
      width: 10px;
      margin-right: 3px;
    }
    & > span {
      font-size: 10px;
      font-weight: 400;
      color: rgba(159, 159, 159, 1);
    }
  }
}
.reply-content {
  margin: 0px 40px 15px 60px;
  width: 260px;
  font-size: 13px;
  color: rgba(0, 0, 0, 1);
  line-height: 15px;
  word-break: break-word;
  white-space: pre-line;
  img {
    margin: 5px 0;
    width: 100%;
    display: block;
  }
  :global {
    .hm-emoji {
      vertical-align: bottom;
    }
  }
}
.footer {
  padding-bottom: 10px;
  width: 100vw;
  font-size: 10px;
  font-weight: 400;
  .reply-number {
    margin-left: 60px;
    display: flex;
    font-size: 11px;
    line-height: 13px;
    word-wrap: break-word;
    color: rgba(159, 159, 159, 1);
    & > img {
      margin-right: 3px;
      width: 10px;
      height: 10px;
      display: inline-block;
      transform: translateY(1px);
    }
    & > span {
      width: 100%;
      display: inline-block;
      color: black;
    }
  }
}
</style>
<style>
.blue {
  color: rgb(64, 125, 231);
}
</style>